module.exports = __webpack_public_path__ + "img/p6.7bed7edc.png";